<template>
    <div class="field--password position--relative">
        <component
            :is="input"
            :settings="{
                label: { class: settings.label.class, text: settings.label.text },
                input: {
                    component: 'InputBasic',
                    id: settings.input.name,
                    type: type,
                    value: '',
                    isRequired: true,
                    fileValidation: settings.input.fileValidation || null,
                    ...settings.input
                },
                allowFilling: true
            }"
        />
        <span
            v-if="hasError"
            class="field--password__eye position--absolute pointer"
            @click="togglePassword"></span>
    </div>
</template>

<script>
// packages
import { ref, computed } from '@vue/composition-api';

export default {
    props: {
        input: Function,
        settings: Object
    },
    setup ( props ) {
        const type = ref( 'password' );

        // dá o toggle da input de passwod, permitindo ao
        // utilizador mostrar || esconder a password.
        const togglePassword = $event => {
            // toggle da classe, de forma aparecer o traço ou não.
            $event.target.classList.toggle( 'js-toggle' );
            type.value = type.value === 'password' ? 'text' : 'password';
        };

        const hasError = computed( () => !props.settings.input.isMissing );

        return {
            type,
            togglePassword,
            hasError
        };
    }
};

</script>

<style lang="scss">
    .field {
        &--password {
            &__eye {
                @include dimensions( 18px, 18px );
                @include transform-position( 55%, 20px, false, false, translateY( -50% ) rotate( 45deg ) );
                border: 2px solid $color-green;
                @include rounded-corner( 70% 15% );
                &::before {
                    @include pseudo();
                    @include dimensions( 9px, 9px );
                    background: $color-green;
                    @include transform-position( 2px, false, false, 2px );
                    @include rounded-corner( 50% );
                }
                &::after {
                    @include pseudo();
                    @include dimensions( 155%, .1em );
                    background: $color-green;
                    @include transform-position( 39%, false, false, -5px, scale( 1 ) );
                    transform-origin: left center;
                    border-top: .1em solid $color-white;
                    @include transition( transform .25s );
                }
                &.js-toggle {
                    &::after {
                        @include transform( scale( 0 ) );
                    }
                }
            }

        }
    }
</style>